export default "__VITE_ASSET__3aa735e6__"